<template>
  <div class="c-profile-content">
    <ul class="c-profile-list">
      <li>
        <div class="headimg">
          <img :src="logoPreview">
        </div>
        <div class="modify-head margin-left">
          <Upload v-on:resetImageName="resetImageName" btnText="上传头像">
            修改头像
          </Upload>

        </div>
      </li>
      <li>
        <div>

          <!--隐藏vip <ul>
            <li>
              <img class="vip-log" v-if="isvip" src="../../assets/vip/VIP_icon.png" @click="govip()">
              <img class="vip-log" v-if="!isvip" src="../../assets/vip/no_vip_icon.png" @click="govip()">
              <button v-if="isvip" @click="govip()" class="vip-btn">VIP续费</button>
              <button v-if="!isvip" @click="govip()" class="vip-btn">开通VIP</button>
            </li>
            <li>
              <p v-if="isvip" class="c-tips1">到期时间:{{expiredTime}}</p>
            </li>
          </ul> -->



        </div>
      </li>
      <!-- <li>
        <p class="c-profile-lf-txt">机构名称 </p>
        <div class="c-profile-rt-input">
          <input v-model="organization" type="text" placeholder="请填写完整准确的机构名称">
        </div>
      </li>
      <li>
        <p class="c-profile-lf-txt">统一社会信用代码</p>
        <div class="c-profile-rt-input">
          <input v-model="scc" type="text" maxlength="18" placeholder="18位统一社会信用代码">
        </div>
      </li> -->
      <li>
        <div class="flex">
          <div class="c-profile-lf-txt">
            <p>机构信息</p>
          </div>
          <button v-show="!applyOrgChecked&&orgObj==null" @click="showApp=true" class="org-btn">绑定机构</button>
          <div class="c-profile-rt-input" v-show="applyOrgChecked||orgObj">{{organization}}</div>
        </div>


        <!-- <p class="c-tips4">请填写完整准确的机构名称和社会信用代码申请机构信息</p> -->
      </li>
      <li>
        <p class="c-profile-lf-txt">邮&nbsp;&nbsp;箱</p>
        <div class="c-profile-rt-input">
          <input v-model="email" type="text" placeholder="工作邮箱">
        </div>
      </li>
    </ul>

    <div class="c-personal-information">
      <!-- <h3 class="c-profile-title">个人信息</h3> -->
      <ul class="c-profile-list">
        <li>
          <p class="c-profile-lf-txt">姓&nbsp;&nbsp;名</p>
          <div class="c-profile-rt-input">
            <input v-model="name" type="text" placeholder="名称">
            <!-- <img src="../../assets/main/tanhao@2x.png"> -->
          </div>
        </li>
        <li>
          <p class="c-profile-lf-txt">性&nbsp;&nbsp;别</p>
          <div class="c-profile-rt-input">
            <label class="c-gender">
              <input type="radio" value="1" v-model="gender" id="male">男
            </label>
            <label class="c-gender">
              <input type="radio" value="0" v-model="gender" id="female">女
            </label>
          </div>
        </li>
        <li>
          <p class="c-profile-lf-txt">证件号码</p>
          <div class="c-profile-rt-input">
            <input v-model="idcard" type="text" maxlength="18" placeholder="">
            <!-- <img src="../../assets/main/tanhao@2x.png"> -->
          </div>
        </li>
        <li>
          <p class="c-profile-lf-txt">联系地址</p>
          <div class="c-profile-rt-input c-profile-rt-input2">
            <div style="display: inline-block;float:left;margin-right:20px;">
              <CityCascader placeholderstr="选择省市" v-on:resetDefaultValue="setAddress" :defaultlevel1name="province"
                :defaultlevel2name="district"></CityCascader>
            </div>
            <input v-model="address" type="text" placeholder="">
          </div>
        </li>
      </ul>
    </div>
    <button @click="modify" class="submit-btn">提交</button>
    <el-dialog title="绑定机构" :visible.sync="showApp">
      <el-form :model="formOrg">
        <el-form-item label="企业名称" :label-width="formLabelWidth">
          <el-input v-model="formOrg.inputorgname" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="社会统一信用代码" :label-width="formLabelWidth">
          <el-input v-model="formOrg.inputScc" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="部门" :label-width="formLabelWidth">
          <el-input v-model="formOrg.inputDept" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="职位" :label-width="formLabelWidth">
          <el-input v-model="formOrg.inputJob" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="showApp = false">取 消</el-button>
        <el-button @click="getOrg">申 请</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import config from '@/config/index';
  import Upload from '@/components/common/Upload';
  import CityCascader from '@/components/common/MyCascader/city'
  import {
    getCacheUserInfo
  } from '@/utils/auth';
  import {
    modifyusrinfo,
    queryVerifycode,
    queryUserInfo,
  } from '@/api/login';
  import {
    validScc,
    validIDcard
  } from '@/utils/validTools.js'
  import {
    getUserinfo,
    getApplyOrgInfoOfUser,
    getOrgUserList
  } from '@/api/personalCenter.js'

  import {
    getOrgByScc,
    applyJoinOrg
  } from '@/api/mos.js'

  import {
    Dialog,
    Button,
    Form,
    FormItem,
    Input,

    MessageBox
  } from 'element-ui'

  export default {
    name: 'Profile',
    props: {
      msg: String,
    },

    components: {
      Upload,
      CityCascader,
      [MessageBox.name]: MessageBox,
      [Dialog.name]: Dialog,
      [Button.name]: Button,
      [Form.name]: Form,
      [FormItem.name]: FormItem,
      [Input.name]: Input,
    },
    data() {
      return {
        showApp: false,
        formLabelWidth:"100",
        formOrg: {
          inputorgname:'',
          inputScc: '',
          inputDept: '',
          inputJob: '',
        },

        orgObj:null,
        name: "",
        gender: "1",
        certificatetype: "1",
        idcard: "",
        email: "",
        province: "",
        district: "",
        address: "",
        headimg: "",
        tag: "",
        organization: "",
        scc: "",
        logoPreview: "",
        isvip: false,
        expiredTime: '',
        applyOrgChecked:''
      }
    },
    mounted() {
      this.queryUserInfo();
    },
    methods: {
      govip() {
        this.$router.push('/vip');
      },
      queryUserInfo() {
        const {
          uid
        } = getCacheUserInfo();
        if (getCacheUserInfo().balance) {
          this.isvip = true
          this.expiredTime = getCacheUserInfo().balance.expiredTime
        } else {
          this.isvip = false
        }
        this.$http.get(getUserinfo(uid)).then(res => {
          console.log('个人信息', res)
          this.name = res.data.user.name
          this.gender = res.data.user.gender
          this.idcard = res.data.user.idcard
          this.email = res.data.user.email
          this.address = res.data.user.address
          this.headimg = res.data.user.headimg ? res.data.user.headimg : "assets/touxiangnan.png"
          this.logoPreview = `${config.HOST_IMG}${this.headimg}`
          this.organization = res.data.user.organization
          this.scc = res.data.user.scc
          this.province = res.data.user.province
          this.district = res.data.user.district
          this.applyOrgChecked = res.data.user.applyOrgChecked
          this.orgObj = res.data.org
        })
      },
      getParams() {
        const uid = getCacheUserInfo().uid;
        return {
          uid: uid,
          name: this.name,
          gender: this.gender,
          certificatetype: 1,
          idcard: this.idcard,
          email: this.email,
          address: this.address,
          headimg: this.headimg,
          tag: this.tag,
          // organization: this.organization,
          // scc: this.scc,
          province: this.province,
          district: this.district,
          provcity: {},
        };
      },
      modify() {
        const params = this.getParams();
        // if (!this.organization) {
        //   this.$message.error('请输入机构名称');
        //   return;
        // }
        // if (!this.scc) {
        //   this.$message.error('请输入社会统一信用代码');
        //   return;
        // }
        // if (!validScc(this.scc)) {
        //   this.$message.error('请输入正确的社会统一信用代码');
        //   return;
        // }
        if (!this.email) {
          this.$message.error('请输入电子邮箱');
          return null;
        }
        if (!this.name) {
          this.$message.error('请输入姓名');
          return null;
        }
        if (!this.idcard) {
          this.$message.error('请输入身份证号码');
          return;
        }
        if (!validIDcard(this.idcard)) {
          this.$message.error('请输入正确的身份证号码');
          return;
        }
        if (!this.province || !this.district) {
          this.$message.error('请选择省市');
          return;
        }
        if (!this.address) {
          this.$message.error('请输入联系地址');
          return;
        }
        // console.log(params)
        this.$http.post(modifyusrinfo(),
          params
        ).then(res => {
          console.log('更改用户信息 res');
          if (res.code === 1) {
            this.$message.success('修改成功');
            return;
          }
          this.$message.error(res.msg || '服务器错误');
        }, err => {

        });
      },
      resetImageName(key) {
        this.headimg = key;
        this.logoPreview = `${config.HOST_IMG}${key}`;
      },
      setAddress(address) {
        this.provcity = address;
        this.province = this.provcity.provName;
        this.district = this.provcity.areaName;
      },
      // searchOrg() {
      //   this.$http.get(getOrgByScc(this.scc)).then(res => {
      //     console.log('申请', res)
      //     if (res.code === 1) {
      //       this.openMsg(res.data.organization, res.data.orgid)
      //     } else {
      //       MessageBox.alert('去创建机构', '申请机构不存在', {
      //         confirmButtonText: '确定',
      //         callback: action => {
      //           MessageBox.message({
      //             type: 'info',
      //             message: `action: ${  this.$router.push('Organization')  }`
      //           });
      //         }
      //       });
      //     }
      //   })
      // },
      applyOrg(orgid) {
        let uid = getCacheUserInfo().uid
        if (!this.formOrg.inputDept || this.formOrg.inputDept == "") {
          this.$message.error("请输入你所在部门")
          return
        }
        let dept = this.formOrg.inputJob
        if (!this.formOrg.inputJob || this.formOrg.inputJob == "") {
          this.$message.error("请输入你的职位")
          return
        }
        let job = this.formOrg.inputJob
        let params = {
          orgid: orgid,
          apply_uid: uid,
          department: dept,
          jobstation: job
        }
        this.$http.post(applyJoinOrg(), params).then(res => {
          if (res.code == 1) {
            this.$message.success("申请成功")
          } else {
            this.$message.error("申请失败")
          }
        })
      },
      openMsg(orgName, orgId) {
        MessageBox.confirm(orgName, '申请成为员工', {
            distinguishCancelAndClose: true,
            confirmButtonText: '确认',
            cancelButtonText: '取消'
          })
          .then(() => {
            this.applyJoin(orgId)
          })
          .catch(action => {

          });
      },
      applyJoin(orgid) {
        let userinfo = getCacheUserInfo()
        const uid = userinfo.uid;

        let params = {
          orgid: orgid, //账号id
          apply_uid: uid,
          department: this.inputDept,
          jobstation: this.inputJob
        }

        this.$http.post(applyJoinOrg(),
          params
        ).then((res) => {
          console.log(res);
          if (res.code === 1) {
            this.$message.success("申请成功");
          } else {
            this.$message.error(res.msg)
          }
        });
      },
      getOrg() {
        this.$http.get(getOrgByScc(this.formOrg.inputScc)).then(res => {
          // console.log(res)
          if (res.code === 1) {
            this.applyOrg(res.data.orgid)
          } else {
            this.$message.error('该机构没有在平台创建')
          }
        })
      },
    }
  };
</script>

<style>
  @import url(./main-m.css);
  @import url(./main.css);
  @import url(../../mainui.css);

  .org-btn {
    width: 130px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    color: #fff;
    background: #267FF2;
    margin: 10px 15px;
    outline: none;
  }

  .apply-org {
    position: fixed;
    width: 80%;
    height: 100%;
    background-color: #FFFFFF;
    z-index: 2;
    top: 0;
    left: 0;
  }

  .formList {}

  .title-lg {
    font-size: 32upx;
    font-weight: 500;
    color: #333333;
    line-height: 44upx;
    padding-top: 40upx;
    margin: 40upx 46upx;
  }

  .formList .title {
    width: 224upx;
    height: 38upx;
    font-size: 28upx;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 40upx;
    margin: 40upx 46upx;
  }

  .formList .content-fix {
    margin: 0 46upx;
    border-bottom: #E0E2E6 solid 2upx;
  }

  .formList .scc {
    width: 400upx;
  }

  .pro-info {
    min-height: 986upx;
    margin: 14upx;
    border-radius: 10upx;
  }
</style>
